module.exports = __webpack_public_path__ + "static/media/3.378b594e.jpg";